import { useEffect, useRef } from 'react';
import { announceToScreenReader } from '../utils/a11y.utils';

const useLoadingAnnouncement = (
	isLoading,
	loadingMessage,
	completeMessage = 'Loading complete'
) => {
	const wasLoadingRef = useRef(false);

	useEffect(() => {
		if (isLoading && !wasLoadingRef.current) {
			announceToScreenReader(loadingMessage, 'assertive');
		} else if (!isLoading && wasLoadingRef.current && completeMessage) {
			announceToScreenReader(completeMessage, 'polite');
		}
		wasLoadingRef.current = isLoading;
	}, [isLoading, loadingMessage, completeMessage]);
};

export default useLoadingAnnouncement;
